// extracted by mini-css-extract-plugin
module.exports = {"container":"ProfileTabs_container__3D4VN","left":"ProfileTabs_left__1MpT2"};